import "react-tooltip/dist/react-tooltip.css";
import type { GetStaticProps } from "next";
import { getMainLayoutQuery, MainLayoutQuery } from "@/lib/sanity/queries";
import { useRouter } from "next/router";
import { useState } from "react";
import { useTranslation } from "@/lib/translations";
import {
  StyledTooltip,
  Container,
  Body,
  EcoLabel,
  InfoIcon,
  EcoIcon,
  CloseTooltip,
  CloseIcon,
} from "./styles";

type Props = {
  layout: MainLayoutQuery;
};

export const getStaticProps: GetStaticProps<Props> = async ({
  locale = "it",
  defaultLocale = "it",
}) => {
  const layout = await getMainLayoutQuery({
    // Get Layout data
    locale,
    defaultLocale,
  });
  return {
    props: {
      layout,
    },
    revalidate: 60,
  };
};

const InfoTooltip: React.FC = () => {
  const router = useRouter();
  const { locale = "it" } = router;
  const t = {
    Title: useTranslation("infoTooltip.Title", locale) || "",
    Description: useTranslation("infoTooltip.Description", locale) || "",
  };

  const [isOpen, setIsOpen] = useState(false);

  return (
    <Container>
      <InfoIcon />
      <StyledTooltip
        anchorSelect="#tooltip-info"
        place="top-start"
        clickable
        closeOnEsc={true}
        closeOnResize={true}
      >
        <EcoLabel>
          <EcoIcon /> <span>{t.Title}</span>
        </EcoLabel>
        <Body>{t.Description}</Body>
      </StyledTooltip>
    </Container>
  );
};
export default InfoTooltip;
